import React, { useEffect, useMemo, useState } from "react"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import {
  faBellConcierge,
  faBolt,
  faCaretRight,
  faChampagneGlasses,
  faClose,
  faCommentDollar,
  faMinus,
  faPlus,
  faTrash,
  faUser,
  faUserAlt,
  faUtensils,
  faLocationDot,
  faWarning,
  faPrint,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons"
import Button, { ButtonIcon } from "../../../components/Button/Button"
import GetSpace from "../../../utils/space"
import { useRegister } from "../../../hooks/Register/useRegister"
import { TitleChildrenPath, TitlePageResponsiveIconSmall } from "../../../components/Titles/Titles"
import {
  catalogItemsMemory,
  extraServiceMemory,
  productsMemory,
  comboMemory,
  customerMemory,
  servicePointMemory,
  addtionalMemory,
  companyMemory,
} from "../../../Objects/Memory/Memory"
import { useError } from "../../../context/useErrorContext"
import { CountElements } from "../../../components/CountElements/CountElements"
import { OrderEntity } from "../../../Objects/Order/OrderEntity"
import { OrderProduct } from "../../../Objects/Order/OrderProduct"
import { OrderCatalogItem } from "../../../Objects/Order/OrderCatalogItem"
import { ProductEntity } from "../../../Objects/ProductsAndCatalogItems/ProductEntity"
import { ElementOrder } from "../../../components/ElementOrder/ElementOrder"
import { useEmployerLogged } from "../../../context/useEmployeeContext"
import { useConfirmation } from "../../../context/useConfirmationContext"
import { CustomerEntity } from "../../../Objects/Customer/CustomerEntity"
import { ServicePoints } from "../../../Objects/ServicePoint/ServicePoints"
import { CalculatePromotions } from "../../../Objects/Calculates/CalculatePromotions"
import { CalculateTotalOrder } from "../../../Objects/Calculates/CalculateTotalOrder"
import { DetailsPaymentPupop } from "./DetailsPaymentPupop"
import { OrderPaymentEntity } from "../../../Objects/Order/OrderPaymentEntity"
import { useSaveOrder } from "../../../hooks/Order/useSaveOrder"
import { convertToLocalMoney } from "../../../Objects/Generics/Helps"
import { EMoneyConditionType } from "../../../Enum/EMoneyConditionType"
import THEME from "../../../configuration/Theme"
import { SIZE } from "../../../configuration/Sizes"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"
import ModalPortal from "../../../components/Modal/ModalPortal"
import { ECustomerPaymentType } from "../../../Enum/ECustomerPaymentType"
import { CalculateView } from "./Components/CalculateView"
import { BasicCard } from "../../../components/BasicCard/BasicCard"
import i18next from "i18next"
import { useTranslation } from "react-i18next"
import { usePermission } from "../../../hooks/Permissions/usePermission"
import { Permissions } from "../../../Enum/PermissionsType"
import { CanView } from "../../../components/CanView/CanView"
import { EOrderCurrentStatus } from "../../../Enum/EOrderCurrentStatus"
import { GenericDropDown } from "../../../components/Dropdown/Dropdown"
import { EOrderPlaceType } from "../../../Enum/EOrderPlaceType"
import { ExtraServiceEntity } from "../../../Objects/ExtraService/ExtraServiceEntity"
import { AwardEntity } from "../../../Objects/Awards/AwardEntity"
import { ListSelections, ListSelectionsProbs } from "../../../components/ListSelections/ListSelections"
import { ViewRegister } from "../../../components/ViewRegister/ViewRegister"
import { CostumerList } from "./Components/CustomerList"
import { CancelOrderPupop } from "./CancelOrderPupop"
import { usePlanUsage } from "../../../hooks/Company/usePlanUsage"
import { PlanUsageStatus } from "../../../Objects/Company/PlanUsageStatus"
import { useUpgradePlan } from "../../../context/useUpgradePlanContext"
import { PlanUsageAlert } from "../../../components/PlanUsageAlert/PlanUsageAlert"
import { getOrderFlowStatusBadges } from "../../../Objects/Order/orderStatusBadges"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { EOrderStatusType } from "../../../Enum/EOrderStatus"
import { ListItem } from "../../../components/List/List"
import { EAccountPlansType } from "../../../Enum/EAccountPlansType"
import { AlertTriangle } from "lucide-react"
import { OrderPrintOptionsPupop } from "../../../components/OrderPrintOptionsPupop/OrderPrintOptionsPupop"
import { SelectionEntity } from "../../../Objects/Selection/SelectionEntity"
import { OrderCatalogProduct } from "../../../Objects/Order/OrderCatalogProduct"
import { CustomerPopup } from "../Customer/CustomerPopup"

const renderProviderChargeReference = (externalReference: string | undefined, label: string) => {
  if (!externalReference) {
    return null
  }

  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-900">
      <span className="font-semibold">{label} </span>

      <span className="break-all font-mono">{externalReference}</span>
    </div>
  )
}

interface OrderPupopProbs {
  order?: OrderEntity

  title: string

  onClonse: () => void

  onSave: () => void | Promise<void>
}

export const OrderPupop: React.FC<OrderPupopProbs> = ({ order, title, onClonse, onSave }) => {
  const { t } = useTranslation("order")

  const titleRemove = t("label_remove")

  const messageRemove = t("message_confirm_remove")

  const titleCantAddService = t("title_already_associated")

  const messageCantAddService = t("message_service_already_associated")

  const canEdite = !usePermission(Permissions.CanEditeOrders)

  const canEditeCustomer = !usePermission(Permissions.CanEditeClients)

  const cloneOrder = (order: OrderEntity) => {
    return new OrderEntity({ ...order })
  }

  const [isCancel, setIsCancel] = useState(false)

  const { handleEnableRegister, handleDisableRegister, isRegisterEnable } = useRegister()

  const { handleSaveOrder } = useSaveOrder()

  const { setError } = useError()

  const { setNewConfirmation } = useConfirmation()

  const { userEmployee } = useEmployerLogged()

  const { handleGetPlanUsage } = usePlanUsage()

  const { openPlan } = useUpgradePlan()

  const [isPayment, setPayment] = useState(false)

  const [calculateTotalOrder] = useState<CalculateTotalOrder>(new CalculateTotalOrder())

  const [enableList, setEnableList] = useState(false)

  const [enableCostumer, setCostumer] = useState(false)

  const [isCustomerEditOpen, setIsCustomerEditOpen] = useState(false)

  const [planUsageStatus, setPlanUsageStatus] = useState<PlanUsageStatus>(new PlanUsageStatus({}))

  const [servicePointSelected, setServicePoint] = useState<ServicePoints | null | undefined>(() => {
    if (order?.servicePointEntity) {
      return order.servicePointEntity
    }

    if (!companyMemory.defaultServicePointId) {
      return null
    }

    return servicePointMemory.listData.find(
      (servicePoint) =>
        servicePoint.id === companyMemory.defaultServicePointId && servicePoint.status === EEnableStatusType.Active,
    )
  })

  const [customerSelected, setCostumerSelect] = useState<CustomerEntity | null | undefined>(() => {
    if (order?.customerEntity) {
      return order.customerEntity
    }

    return customerMemory.listData.find((customer) => customer.isDefaultCustomer)
  })

  const [deliveryAddressSelectedId, setDeliveryAddressSelectedId] = useState<number>(order?.addressEntityId ?? 0)

  const [dataListSelected, setListSelect] = useState<ListSelectionsProbs>()

  const [orderPlaceType, setOrderPlaceType] = useState<EOrderPlaceType>(order?.eOrderPlaceType || EOrderPlaceType.Local)

  const [isStorePickup, setIsStorePickup] = useState<boolean>(order?.isStorePickup ?? false)

  const isDefaultCustomerSelected = customerSelected?.isDefaultCustomer === true

  const isDeliveryWithoutRealCustomer =
    orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && isDefaultCustomerSelected

  const customerDeliveryAddresses = customerSelected?.personEntity?.addresses ?? []

  const shouldShowDeliveryAddressArea =
    orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && !!customerSelected && !isDefaultCustomerSelected

  const deliveryAddressOptions = [
    { value: "", label: t("label_select_delivery_address_placeholder") },
    ...customerDeliveryAddresses.map((address) => ({
      value: address.id.toString(),
      label: `${address.label} - ${address.street}, ${address.number} - ${address.neighborhood}`,
    })),
  ]

  const [isPrintTargetModalOpen, setIsPrintTargetModalOpen] = useState(false)

  const [productsList, setProductsList] = useState<OrderProduct[]>(
    order ? order.orderProducts.map((e) => new OrderProduct({ ...e })) : [],
  )

  const [catalogItemsList, setCatalogItemsList] = useState<OrderCatalogItem[]>(
    order ? order.orderCatalogItems.map((e) => new OrderCatalogItem({ ...e })) : [],
  )

  const [orderFinal, setOrderFinal] = useState<OrderEntity>(() => {
    return order ? cloneOrder(order) : new OrderEntity({})
  })

  const isServicePointSelfServiceOrder = order?.isServicePointSelfServiceOrder() ?? false

  const orderFlowBadges = useMemo(() => {
    if (!order) {
      return []
    }

    return getOrderFlowStatusBadges(order, companyMemory.orderPaymentTimeoutMinutes)
  }, [order, companyMemory.orderPaymentTimeoutMinutes])

  const [extraServicesList, setExtraServices] = useState<ExtraServiceEntity[]>(() => {
    if (order) {
      return order.extraServices
    }

    const extraService: ExtraServiceEntity[] = []

    extraServiceMemory.listData.forEach((e) => {
      if (e.isAutomatic && e.status === EEnableStatusType.Active) {
        extraService.push(e)
      }
    })

    return extraService
  })

  useEffect(() => {
    if (order) {
      setOrderFinal(order)
      setDeliveryAddressSelectedId(order.addressEntityId ?? 0)
      setIsStorePickup(order.isStorePickup ?? false)
    }
  }, [order, catalogItemsList, productsList, extraServicesList])

  useEffect(() => {
    if (orderPlaceType !== EOrderPlaceType.Delivery) {
      setDeliveryAddressSelectedId(0)
      setIsStorePickup(false)
      return
    }

    if (isStorePickup) {
      setDeliveryAddressSelectedId(0)
      return
    }

    if (isDefaultCustomerSelected) {
      setDeliveryAddressSelectedId(0)
      return
    }

    const addresses = customerSelected?.personEntity?.addresses ?? []

    if (addresses.length === 0) {
      setDeliveryAddressSelectedId(0)
      return
    }

    const hasSelectedAddress = addresses.some((address) => address.id === deliveryAddressSelectedId)

    if (!hasSelectedAddress) {
      setDeliveryAddressSelectedId(addresses[0].id)
    }
  }, [orderPlaceType, customerSelected, deliveryAddressSelectedId, isStorePickup, isDefaultCustomerSelected])

  useEffect(() => {
    if (companyMemory.subscriptionEntity.eAccountPlansType === EAccountPlansType.Scale) {
      return
    }

    handleGetPlanUsage((usage) => {
      setPlanUsageStatus(usage)

      if (usage.isLimitReached) {
        openPlan(usage)
      }
    })
  }, [])

  const handleCaculate = () => {
    if (!customerSelected) {
      return
    }

    productsList.forEach((e) => {
      e.calculatePromotions = new CalculatePromotions({
        customer: customerSelected,

        addtionals: e.addtionals,
        selections: e.selections,

        productsAndCatalogItems: e.productEntity.catalogProductEntity,
        timeZoneId: companyMemory.timeZoneId,
      })

      e.calculatePromotions?.calculate()
    })

    catalogItemsList.forEach((e) => {
      e.calculatePromotions = new CalculatePromotions({
        customer: customerSelected,

        addtionals: e.addtionals,
        selections: e.selections,

        productsAndCatalogItems: e.catalogItemEntity.catalogProductEntity,
        timeZoneId: companyMemory.timeZoneId,
      })

      e.calculatePromotions?.calculate()
    })

    setProductsList(productsList)
    setCatalogItemsList(catalogItemsList)

    let awardManagers: AwardEntity[] = []

    if (order?.id > 0) {
      awardManagers = order.associatedAwards
    } else {
      awardManagers = customerSelected.awardManagers.map((e) => e.awardEntity)
    }

    calculateTotalOrder.calculate(productsList, catalogItemsList, extraServicesList, awardManagers, order?.couponEntity)
  }

  useMemo(
    () => handleCaculate(),
    [
      servicePointSelected,
      customerSelected,
      productsList,
      catalogItemsList,
      extraServicesList,
      order,
      calculateTotalOrder,
    ],
  )

  const getMissingRequiredSelections = (item: OrderCatalogProduct, allowedSelections: SelectionEntity[]) => {
    return allowedSelections.filter(
      (selection) =>
        selection.status === EEnableStatusType.Active &&
        selection.isRequired &&
        item.selections.filter((current) => current.selectionEntityId === selection.id).length <
          Math.max(1, selection.requiredOptionsCount ?? 1),
    )
  }

  const getMissingRequiredSelectionsMessage = () => {
    const productMessages = productsList.flatMap((product) =>
      getMissingRequiredSelections(product, product.productEntity.catalogProductEntity.allowedSelections ?? []).map(
        (selection) => `${product.productEntity.catalogProductEntity.name}: ${selection.name}`,
      ),
    )

    const catalogItemMessages = catalogItemsList.flatMap((catalogItem) =>
      getMissingRequiredSelections(
        catalogItem,
        catalogItem.catalogItemEntity.catalogProductEntity.allowedSelections ?? [],
      ).map((selection) => `${catalogItem.catalogItemEntity.catalogProductEntity.name}: ${selection.name}`),
    )

    return [...productMessages, ...catalogItemMessages]
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/immutability
    CreateOrder()
  }, [
    servicePointSelected,
    customerSelected,
    productsList,
    catalogItemsList,
    extraServicesList,
    order,
    calculateTotalOrder,
  ])

  const CreateOrder = (): OrderEntity => {
    if (!customerSelected) {
      return orderFinal
    }

    handleCaculate()

    const newOrder = new OrderEntity({
      ...order,

      id: order?.id || -1,

      customerEntity: customerSelected,

      servicePointEntity: servicePointSelected || new ServicePoints({}),

      orderPaymentEntity: new OrderPaymentEntity({
        ...order?.orderPaymentEntity,

        id: order?.orderPaymentEntity.id || -1,

        status: order?.orderPaymentEntity.status || ECustomerPaymentType.WithInDebit,

        description: "",

        totalAward: calculateTotalOrder.valueTotalAwards,

        totalProducts: calculateTotalOrder.valueBaseProducts,

        totalCatalogItems: calculateTotalOrder.valueBaseCatalogItems,

        totalNotLiquid: calculateTotalOrder.valueBaseSun,

        totalDiscount: calculateTotalOrder.valueTotalDiscount,

        totalBase: calculateTotalOrder.valueBaseSunWithDiscout,

        totalExtra: calculateTotalOrder.valueBaseExtraServices,

        totalFinal: calculateTotalOrder.valuefinal,

        totalAddtionals: calculateTotalOrder.valueAddtionals,
      }),

      associatedAwards: order?.associatedAwards ?? [],

      orderCatalogItems: catalogItemsList,

      orderProducts: productsList,

      eOrderPlaceType: orderPlaceType,

      isStorePickup: orderPlaceType === EOrderPlaceType.Delivery ? isStorePickup : false,

      extraServices: extraServicesList,

      addressEntityId:
        orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && !isDefaultCustomerSelected
          ? deliveryAddressSelectedId
          : 0,

      addressEntity:
        orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && !isDefaultCustomerSelected
          ? (customerSelected.personEntity?.addresses.find((e) => e.id === deliveryAddressSelectedId) ?? null)
          : null,

      isCancel: false,
    })

    setOrderFinal(newOrder)

    return newOrder
  }

  const handleOpenAddProducts = () => {
    const productsCards = productsMemory.getListCards(true).filter((e) => e.canUse)

    const comboCards: ListItem[] = comboMemory
      .getListCards(true)
      .filter((e) => e.canUse)
      .map((card) => {
        const combo = comboMemory.findById(card.id)

        if (!combo) {
          return card
        }

        return {
          ...card,
          id: combo.productId,
          title: `🧩 ${card.title}`,
          dataFilter: [...(card.dataFilter ?? []), "combo"],
        }
      })

    const listCards = [...productsCards, ...comboCards]
      .filter((card, index, array) => array.findIndex((current) => current.id === card.id) === index)
      .sort((a, b) => a.title.localeCompare(b.title))

    setListSelect({
      title: i18next.t("order:title_products"),

      icon: faUtensils,

      listCards: listCards,

      onClinck: (e: number) => handleAddProducts(e),

      messageCount: i18next.t("order:message_products_found"),

      messageEmpty: i18next.t("order:message_products_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddServicePoints = () => {
    setListSelect({
      title: "Selecione umo ponto de atendimento",

      icon: faLocationDot,

      listCards: servicePointMemory.getListCards(true),

      onClinck: (e: number) => {
        setServicePoint(servicePointMemory.findById(e)!)

        setEnableList(false)
      },

      messageCount: "Pontos de atendimento encontradas na busca.",

      messageEmpty: i18next.t("order:message_servicePoints_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddCatalogItems = () => {
    setListSelect({
      title: "Selecione uma item complementar",

      icon: faChampagneGlasses,

      listCards: catalogItemsMemory.getListCards(true).filter((e) => e.canUse),

      onClinck: (e: number) => {
        handleAddCatalogItems(e)
      },

      messageCount: "Itens complementares encontradas na busca.",

      messageEmpty: i18next.t("order:message_catalogItems_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddServices = () => {
    setListSelect({
      title: i18next.t("order:title_extra_services"),

      icon: faBellConcierge,

      listCards: extraServiceMemory.getListCards(false),

      onClinck: (e: number) => {
        const serviceToAdd = extraServiceMemory.findById(e)

        if (!serviceToAdd || serviceToAdd.status !== EEnableStatusType.Active) {
          setEnableList(false)
          return
        }

        if (extraServicesList.find((ss) => ss.id === e) === undefined)
          setExtraServices([...extraServicesList, serviceToAdd])
        else setError(titleCantAddService, messageCantAddService)

        setEnableList(false)
      },

      messageCount: i18next.t("order:message_services_found"),

      messageEmpty: i18next.t("order:message_services_empty"),

      onClonse: () => setEnableList(false),
    })

    setEnableList(true)
  }

  const handleOpenAddCostumer = () => {
    setCostumer(true)
  }

  const handleCloseCustomerEdit = () => {
    const customerId = customerSelected?.id

    if (customerId && customerId > 0) {
      setCostumerSelect(customerMemory.findById(customerId) ?? customerSelected)
    }

    setIsCustomerEditOpen(false)
  }

  const handleSaved = async () => {
    onClonse()

    await onSave()
  }

  const handleTrySubmit = async () => {
    if (planUsageStatus.isLimitReached) {
      setError(t("title_plan_limit_reached"), t("message_plan_limit_reached"))
      openPlan()
      return
    }

    const missingRequiredSelections = getMissingRequiredSelectionsMessage()

    if (missingRequiredSelections.length > 0) {
      setError(
        t("title_required_selection_missing"),
        t("message_required_selection_missing_summary", { selections: missingRequiredSelections.join(", ") }),
      )
      return
    }

    if (isDeliveryWithoutRealCustomer) {
      setError(t("title_delivery_requires_real_customer"), t("message_delivery_requires_real_customer"))
      return
    }

    if (orderPlaceType === EOrderPlaceType.Delivery && !isStorePickup && deliveryAddressSelectedId <= 0) {
      setError(i18next.t("order:title_address_required"), i18next.t("order:message_select_delivery_address"))
      return
    }

    handleSaveOrder(CreateOrder(), handleSaved)
  }

  const handleRemoveProducts = (e: OrderProduct) => {
    setProductsList((prev) => prev.filter((ss) => ss !== e))
  }

  const handleRemoveCatalogItems = (e: OrderCatalogItem) => {
    setCatalogItemsList((prev) => prev.filter((ss) => ss !== e))
  }

  const handleRemoveServices = (e: ExtraServiceEntity) => {
    setExtraServices((prev) => prev.filter((ss) => ss !== e))
  }

  const handleAddProducts = (e: number) => {
    const productFromMemory = productsMemory.findById(e)

    const product =
      productFromMemory ??
      (() => {
        const combo = comboMemory.listData.find((comboItem) => comboItem.productId === e)

        if (!combo) {
          return null
        }

        return new ProductEntity({
          id: combo.productId,
          catalogProductEntity: combo.catalogProductEntity,
        })
      })()

    if (!product) {
      setError(i18next.t("general:label_invalid"), t("message_product_unavailable"))
      setEnableList(false)
      return
    }

    const temp: OrderProduct[] = [
      ...productsList,

      new OrderProduct({
        productEntity: product,

        description: "",

        valueBase: product.catalogProductEntity.valueBase.toString().toNumber(),

        employeeEditeId: userEmployee?.id,

        productEntityId: product.id,
      }),
    ]

    setProductsList(temp)

    setEnableList(false)
  }

  const handleAddCatalogItems = (e: number) => {
    const catalogItem = catalogItemsMemory.findById(e)!

    const temp: OrderCatalogItem[] = [
      ...catalogItemsList,

      new OrderCatalogItem({
        catalogItemEntity: catalogItem,

        description: "",

        valueBase: catalogItem.catalogProductEntity.valueBase.toString().toNumber(),

        employeeEditeId: userEmployee?.id,

        catalogItemEntityId: catalogItem.id,
      }),
    ]

    setCatalogItemsList(temp)

    setEnableList(false)
  }

  return (
    <ModalPortal>
      <div className={defaultStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defaultStyle.alert}>
            <TitlePageResponsiveIconSmall
              iconColor={THEME.colors.iconBGColor}
              title={title}
              icon={faCommentDollar}
              subtitleChildren={
                <div className={`w-[420px] md:w-[500px] ${defaultStyle.ButtonsActions}`}>
                  <GenericDropDown
                    data={Object.mapEnumToStrings(EOrderPlaceType)}
                    initialState={orderPlaceType}
                    handlerFuncion={(e) => setOrderPlaceType(e.currentTarget.selectedIndex as EOrderPlaceType)}
                    disable={canEdite}
                    descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.select.select"
                  />

                  {order && order.id > 0 && (
                    <>
                      <GetSpace left={5} />

                      <ButtonIcon
                        typeButton="button"
                        sizeNumber={SIZE.buttonCloseIconSize}
                        bgColor={THEME.colors.buttonBGSaveColor}
                        iconColor={THEME.colors.buttonFGSaveColor}
                        icon={faPrint}
                        onClick={() => setIsPrintTargetModalOpen(true)}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setIsPrintTargetModalOpenTrue"
                      />
                    </>
                  )}

                  <GetSpace left={5} />

                  <ButtonIcon
                    sizeNumber={SIZE.buttonCloseIconSize}
                    bgColor={THEME.colors.buttonBGCloseColor}
                    iconColor={THEME.colors.buttonFGCloseColor}
                    icon={faClose}
                    onClick={onClonse}
                    size="small"
                    descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.onClonse"
                  />
                </div>
              }
            />

            <GetSpace top={5} />

            {isDeliveryWithoutRealCustomer && (
              <>
                <div className="rounded-xl border-2 border-red-500 bg-red-50 px-4 py-3 text-red-800 shadow-sm">
                  <div className="flex items-start gap-3">
                    <AlertTriangle size={22} className="mt-0.5 shrink-0 text-red-700" />

                    <div className="flex flex-col gap-1">
                      <strong className="text-sm font-extrabold uppercase tracking-wide">
                        {t("title_delivery_requires_real_customer")}
                      </strong>

                      <span className="text-sm font-semibold leading-snug">
                        {t("message_delivery_requires_real_customer")}
                      </span>
                    </div>
                  </div>
                </div>

                <GetSpace top={5} />
              </>
            )}

            {order?.orderPaymentEntity.isOnlinePayment &&
              renderProviderChargeReference(
                order.orderPaymentEntity.externalReference,
                t("label_provider_external_reference"),
              )}

            <PlanUsageAlert planUsageStatus={planUsageStatus} />

            {!planUsageStatus.isLimitReached && (
              <>
                <GetSpace top={15} />

                <form onSubmit={handleTrySubmit}>
                  {isServicePointSelfServiceOrder && (
                    <>
                      <Animate type={AnimationTypes.fadeInTraslate} duration="1.5s">
                        <div className="rounded-xl border-2 border-violet-300 bg-violet-50 p-2 text-violet-800">
                          <p className="text-xs font-black uppercase tracking-wider">
                            {t("label_service_point_self_service_order")}
                          </p>

                          <p className="mt-2 text-sm font-bold">{order?.getCustomerDisplayName()}</p>

                          <p className="mt-1 text-xs font-semibold">
                            {t("label_cpf")}: {order?.getCustomerDisplayCpf()}
                          </p>
                        </div>
                      </Animate>

                      <GetSpace top={10} />
                    </>
                  )}

                  {orderFlowBadges.length > 0 && (
                    <>
                      <Animate type={AnimationTypes.fadeIn} duration="1.5s">
                        <div className="flex flex-wrap items-center gap-2 px-1">
                          <span className="text-[11px] font-semibold text-gray-500">
                            {i18next.t("order:status_flow_title")}
                          </span>

                          {orderFlowBadges.map((badge) => (
                            <span
                              key={`${order?.id}-${badge.label}`}
                              className={`px-2 py-1 text-[11px] font-semibold rounded-full ${badge.className}`}
                            >
                              {badge.label}
                            </span>
                          ))}
                        </div>
                      </Animate>

                      <GetSpace top={5} />
                    </>
                  )}

                  {customerSelected ? (
                    <TitlePageResponsiveIconSmall
                      iconColor={THEME.colors.iconBGSecondaryColor}
                      boxShadow="none"
                      title={
                        isServicePointSelfServiceOrder
                          ? order?.getCustomerDisplayName()
                          : customerSelected.personEntity.name
                      }
                      icon={faUser}
                      subtitleChildren={
                        <>
                          {isServicePointSelfServiceOrder && (
                            <BasicCard title={order?.getCustomerDisplayCpf() ?? ""} borderColor={THEME.colors.white} />
                          )}

                          {!isServicePointSelfServiceOrder && !customerSelected.isDefaultCustomer && (
                            <BasicCard title={customerSelected.personEntity.cpf} borderColor={THEME.colors.white} />
                          )}

                          {!isServicePointSelfServiceOrder && customerSelected.isDefaultCustomer && (
                            <div className=" flex items-center gap-2 rounded-lg border-2 border-amber-400 bg-amber-50 px-3 py-2 text-red-600">
                              <AlertTriangle size={16} className="shrink-0 text-red-800" />

                              <span className="flex-1 text-xs font-bold text-center uppercase tracking-wide whitespace-nowrap overflow-hidden text-ellipsis">
                                {t("label_default_customer")}
                              </span>
                            </div>
                          )}

                          {!isServicePointSelfServiceOrder && !customerSelected.isDefaultCustomer && (
                            <>
                              <GetSpace left={5} />

                              <ButtonIcon
                                animationTypes={AnimationTypes.fadeIn}
                                sizeNumber={SIZE.buttonExpandIcon}
                                bgColor={THEME.colors.buttonBGSaveColor}
                                iconColor={THEME.colors.buttonFGSaveColor}
                                icon={faPenToSquare}
                                disabled={canEditeCustomer}
                                onClick={() => setIsCustomerEditOpen(true)}
                                size="small"
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setIsCustomerEditOpenTrue"
                              />
                            </>
                          )}

                          {(!order || order?.id < 1) && (
                            <>
                              <GetSpace left={5} />

                              <ButtonIcon
                                animationTypes={AnimationTypes.fadeIn}
                                sizeNumber={SIZE.buttonExpandIcon}
                                bgColor={THEME.colors.buttonBGRemoveColor}
                                iconColor={THEME.colors.buttonFGRemoveColor}
                                icon={faTrash}
                                disabled={canEdite}
                                onClick={() => {
                                  setCostumerSelect(null)
                                  handleOpenAddCostumer()
                                }}
                                size="small"
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.faTrash"
                              />
                            </>
                          )}
                        </>
                      }
                    />
                  ) : (
                    <TitlePageResponsiveIconSmall
                      iconColor={THEME.colors.iconBGColor}
                      subtitle={t("label_select_customer")}
                      icon={faUserAlt}
                      boxShadow="none"
                      children={
                        <ButtonIcon
                          sizeNumber={SIZE.buttonExpandIcon}
                          bgColor={THEME.colors.buttonBGPlusColor}
                          iconColor={THEME.colors.buttonFGPlusColor}
                          icon={faPlus}
                          disabled={canEdite}
                          onClick={handleOpenAddCostumer}
                          size="small"
                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddCostumer"
                        />
                      }
                    />
                  )}

                  {shouldShowDeliveryAddressArea && (
                    <>
                      <GetSpace top={5} />

                      {customerDeliveryAddresses.length > 0 ? (
                        <TitlePageResponsiveIconSmall
                          iconColor={THEME.colors.iconBGColor}
                          title={i18next.t("order:title_delivery_address")}
                          icon={faLocationDot}
                          boxShadow="none"
                          children={
                            <GenericDropDown
                              data={deliveryAddressOptions}
                              initialState={deliveryAddressSelectedId > 0 ? deliveryAddressSelectedId.toString() : ""}
                              disable={canEdite}
                              handlerFuncion={(event) =>
                                setDeliveryAddressSelectedId(Number(event.currentTarget.value || 0))
                              }
                              descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.select.select2"
                            />
                          }
                        />
                      ) : (
                        <div className="rounded-xl border-2 border-amber-400 bg-amber-50 px-4 py-3 text-amber-900 shadow-sm">
                          <div className="flex items-start gap-3">
                            <AlertTriangle size={20} className="mt-0.5 shrink-0 text-amber-700" />

                            <div className="flex flex-col gap-1">
                              <strong className="text-sm font-extrabold uppercase tracking-wide">
                                {t("title_customer_without_delivery_address")}
                              </strong>

                              <span className="text-sm font-semibold leading-snug">
                                {t("message_customer_without_delivery_address")}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {orderPlaceType === EOrderPlaceType.Local && (
                    <>
                      <GetSpace top={5} />

                      {servicePointSelected ? (
                        <TitlePageResponsiveIconSmall
                          iconColor={THEME.colors.iconBGSecondaryColor}
                          boxShadow="none"
                          title={i18next.t("components:label_servicePoints")}
                          icon={faLocationDot}
                          subtitleChildren={
                            <>
                              <BasicCard title={servicePointSelected.name} borderColor={THEME.colors.white} />

                              <GetSpace left={5} />

                              <ButtonIcon
                                sizeNumber={SIZE.buttonExpandIcon}
                                bgColor={THEME.colors.buttonBGRemoveColor}
                                iconColor={THEME.colors.buttonFGRemoveColor}
                                icon={faTrash}
                                disabled={canEdite}
                                onClick={() => setServicePoint(null)}
                                size="small"
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setTableNull"
                              />
                            </>
                          }
                        />
                      ) : (
                        <TitlePageResponsiveIconSmall
                          iconColor={THEME.colors.iconBGColor}
                          subtitle={"Selecionar Ponto de atendimento"}
                          boxShadow="none"
                          icon={faLocationDot}
                          children={
                            <ButtonIcon
                              sizeNumber={SIZE.buttonExpandIcon}
                              bgColor={THEME.colors.buttonBGPlusColor}
                              iconColor={THEME.colors.buttonFGPlusColor}
                              icon={faPlus}
                              disabled={canEdite}
                              onClick={handleOpenAddServicePoints}
                              size="small"
                              descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddTables"
                            />
                          }
                        />
                      )}
                    </>
                  )}

                  <div className={defaultStyle.divisionBar}></div>

                  <TitleChildrenPath
                    title={i18next.t("order:title_products")}
                    iconColor={THEME.colors.iconBGColor}
                    icon={faUtensils}
                    boxShadow="none"
                    subtitleChildren={
                      <ButtonIcon
                        sizeNumber={SIZE.buttonExpandIcon}
                        bgColor={THEME.colors.buttonBGRegisterColor}
                        iconColor={THEME.colors.buttonFGRegisterColor}
                        icon={faPlus}
                        typeButton="button"
                        disabled={canEdite}
                        onClick={handleOpenAddProducts}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddMeals"
                      />
                    }
                    children={
                      <>
                        <GetSpace top={5} />

                        {productsList.length > 0 && (
                          <>
                            <CountElements
                              count={productsList.length}
                              title={i18next.t("order:title_products_dots")}
                              boxShadow={"none"}
                            />

                            <GetSpace top={5} />

                            {productsList.map((e, index) => {
                              return (
                                <React.Fragment key={index * 3000}>
                                  <GetSpace top={5} />

                                  <ElementOrder
                                    allowedAddtionals={e.productEntity.catalogProductEntity.allowedAddtionals}
                                    addtionalsItems={addtionalMemory

                                      .getListCards(false)

                                      .filter((card) =>
                                        e.productEntity.catalogProductEntity.allowedAddtionals
                                          .map((e) => e.id)
                                          .includes(card.id),
                                      )}
                                    selectionsItems={(
                                      e.productEntity.catalogProductEntity.allowedSelections ?? []
                                    ).filter((selection) => selection.status === EEnableStatusType.Active)}
                                    urlImage={e.productEntity.catalogProductEntity.iconUrl.toClientRequest()}
                                    employeeStringId={e.employeeEditeId}
                                    calculatePromotions={e.calculatePromotions}
                                    date={e.date}
                                    isClosed={e.currentStatus === EOrderCurrentStatus.Closed}
                                    disable={canEdite}
                                    key={index}
                                    icon={faBolt}
                                    genericOrderProduct={e}
                                    onEditeAddtional={CreateOrder}
                                    onRemove={() => {
                                      setNewConfirmation(titleRemove, messageRemove, () => handleRemoveProducts(e))
                                    }}
                                    title={e.productEntity.catalogProductEntity.name}
                                  />
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}
                      </>
                    }
                  />

                  <div className={defaultStyle.divisionBar}></div>

                  <TitleChildrenPath
                    iconColor={THEME.colors.iconBGColor}
                    title={"Itens complementares"}
                    boxShadow="none"
                    icon={faChampagneGlasses}
                    subtitleChildren={
                      <ButtonIcon
                        sizeNumber={SIZE.buttonExpandIcon}
                        bgColor={THEME.colors.buttonBGRegisterColor}
                        iconColor={THEME.colors.buttonFGRegisterColor}
                        icon={faPlus}
                        disabled={canEdite}
                        onClick={handleOpenAddCatalogItems}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddDrinks"
                      />
                    }
                    children={
                      <>
                        <GetSpace top={5} />

                        {catalogItemsList.length > 0 && (
                          <>
                            <CountElements
                              count={catalogItemsList.length}
                              title={"Itens complementares..."}
                              boxShadow={"none"}
                            />

                            <GetSpace top={5} />

                            {catalogItemsList.map((e, index) => {
                              return (
                                <React.Fragment key={e.id ?? index}>
                                  <GetSpace top={5} />

                                  <ElementOrder
                                    allowedAddtionals={e.catalogItemEntity.catalogProductEntity.allowedAddtionals}
                                    addtionalsItems={addtionalMemory

                                      .getListCards(false)

                                      .filter((card) =>
                                        e.catalogItemEntity.catalogProductEntity.allowedAddtionals

                                          .map((e) => e.id)

                                          .includes(card.id),
                                      )}
                                    selectionsItems={(
                                      e.catalogItemEntity.catalogProductEntity.allowedSelections ?? []
                                    ).filter((selection) => selection.status === EEnableStatusType.Active)}
                                    urlImage={e.catalogItemEntity.catalogProductEntity.iconUrl.toClientRequest()}
                                    employeeStringId={e.employeeEditeId}
                                    title={e.catalogItemEntity.catalogProductEntity.name}
                                    calculatePromotions={e.calculatePromotions}
                                    isClosed={e.currentStatus === EOrderCurrentStatus.Closed}
                                    date={e.date}
                                    key={index}
                                    disable={canEdite}
                                    icon={faBolt}
                                    genericOrderProduct={e}
                                    onEditeAddtional={CreateOrder}
                                    onRemove={() => {
                                      setNewConfirmation(titleRemove, messageRemove, () => handleRemoveCatalogItems(e))
                                    }}
                                  />
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}
                      </>
                    }
                  />

                  <div className={defaultStyle.divisionBar}></div>

                  <TitleChildrenPath
                    iconColor={THEME.colors.iconBGColor}
                    title={i18next.t("order:title_extra_services_lower")}
                    icon={faBellConcierge}
                    boxShadow="none"
                    subtitleChildren={
                      <ButtonIcon
                        sizeNumber={SIZE.buttonExpandIcon}
                        bgColor={THEME.colors.buttonBGRegisterColor}
                        iconColor={THEME.colors.buttonFGRegisterColor}
                        icon={faPlus}
                        typeButton="button"
                        disabled={canEdite}
                        onClick={handleOpenAddServices}
                        size="small"
                        descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.handleOpenAddServices"
                      />
                    }
                    children={
                      <>
                        {extraServicesList.length > 0 && (
                          <>
                            <CountElements
                              count={extraServicesList.length}
                              title={i18next.t("order:title_extra_services_dots")}
                              boxShadow={"none"}
                            />

                            {extraServicesList.map((e, index) => {
                              return (
                                <div
                                  className="rounded-lg mt-1 border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40 p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md"
                                  key={e.id ?? index}
                                >
                                  <GetSpace top={5} />

                                  <TitlePageResponsiveIconSmall
                                    title={e.name}
                                    icon={faCaretRight}
                                    sizeProp="sm"
                                    boxShadow="none"
                                    subtitleChildren={
                                      <>
                                        <BasicCard
                                          borderColor={THEME.colors.white}
                                          txtColor={THEME.colors.iconBGAlertColor}
                                          title={
                                            e.conditionType === EMoneyConditionType.Percentage
                                              ? `${e.valueBase}%`
                                              : convertToLocalMoney(e.valueBase)
                                          }
                                        />

                                        <GetSpace left={5} />

                                        <ButtonIcon
                                          sizeNumber={SIZE.buttonExpandIcon}
                                          bgColor={THEME.colors.buttonBGCloseColor}
                                          icon={faMinus}
                                          disabled={canEdite}
                                          typeButton="button"
                                          onClick={() =>
                                            setNewConfirmation(titleRemove, messageRemove, () =>
                                              handleRemoveServices(e),
                                            )
                                          }
                                          size="small"
                                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.setNewConfirmationTitleRemoveMessageRemoveHandleRemoveServic"
                                        />
                                      </>
                                    }
                                  />
                                </div>
                              )
                            })}
                          </>
                        )}
                      </>
                    }
                  />

                  <div className={defaultStyle.divisionBar}></div>

                  <CalculateView
                    valueBaseProducts={calculateTotalOrder.valueBaseProducts}
                    valueBaseCatalogItems={calculateTotalOrder.valueBaseCatalogItems}
                    valueAddtionals={calculateTotalOrder.valueAddtionals}
                    valueBaseSum={calculateTotalOrder.valueBaseSun}
                    valueTotalShippingFee={order?.orderPaymentEntity.shippingFee ?? 0}
                    valueTotalDiscount={calculateTotalOrder.valueTotalDiscount}
                    valueBaseSumWithDiscount={calculateTotalOrder.valueBaseSunWithDiscout}
                    valueBaseExtraServices={calculateTotalOrder.valueBaseExtraServices}
                    valueTotalAwards={calculateTotalOrder.valueTotalAwards}
                    valueFinalWithoutAwards={calculateTotalOrder.valuefinalWithoutAwards}
                    valueTotalCoupons={calculateTotalOrder.valueTotalCupons}
                    valueFinal={calculateTotalOrder.valuefinal + (order?.orderPaymentEntity.shippingFee ?? 0)}
                    awards={order?.associatedAwards}
                  />

                  <div className={defaultStyle.divisionBar}></div>

                  {!servicePointSelected && orderPlaceType === EOrderPlaceType.Local && (
                    <span className="flex text-sm justify-center text-red-600 font-bold">
                      Por favor selecione umo ponto de atendimento para salvar
                    </span>
                  )}

                  <div className={defaultStyle.buttonsController}>
                    <CanView permission={Permissions.CanEditeOrders}>
                      {((orderPlaceType === EOrderPlaceType.Local && servicePointSelected) ||
                        (orderPlaceType === EOrderPlaceType.Delivery &&
                          !isDeliveryWithoutRealCustomer &&
                          customerSelected &&
                          (isStorePickup || deliveryAddressSelectedId > 0) &&
                          !order?.orderPaymentEntity.isOnlinePayment &&
                          order?.eOrderStatusType !== EOrderStatusType.Delivered)) && (
                        <Button
                          label={t("buttons:button_save")}
                          typeButton="button"
                          type="primary"
                          size="medium"
                          onClick={() => handleTrySubmit()}
                          bgColor={THEME.colors.buttonBGSaveColor}
                          disabled={planUsageStatus.isLimitReached}
                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.save"
                        />
                      )}
                    </CanView>

                    {order && (
                      <>
                        <CanView permission={Permissions.CanEditeOrders}>
                          {(order.eOrderPlaceType !== EOrderPlaceType.Delivery ||
                            order.addressEntityId === deliveryAddressSelectedId) && (
                            <>
                              <GetSpace left={5} />

                              <Button
                                label={t("buttons:button_pay")}
                                typeButton="button"
                                type="primary"
                                size="medium"
                                bgColor={THEME.colors.buttonBGRemoveColor}
                                onClick={() => setPayment(true)}
                                descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.pay"
                              />
                            </>
                          )}

                          <GetSpace left={5} />

                          <Button
                            label={t("buttons:button_cancel")}
                            typeButton="button"
                            type="primary"
                            size="medium"
                            bgColor={THEME.colors.buttonBGCloseColor}
                            onClick={() => setIsCancel(true)}
                            descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.cancel"
                          />
                        </CanView>

                        <GetSpace right={5} />

                        <Button
                          label={t("buttons:button_register")}
                          typeButton="button"
                          type="primary"
                          size="medium"
                          bgColor={THEME.colors.buttonBGRegisterColor}
                          onClick={handleEnableRegister}
                          descriptionKey="interactionDescriptions:pages.fluxo.order.orderPupop.button.register"
                        />
                      </>
                    )}
                  </div>
                </form>
              </>
            )}
          </div>
        </Animate>

        {isRegisterEnable && order && (
          <ViewRegister id={order.id} typeEntity="OrderEntityId" onClose={handleDisableRegister} />
        )}

        {enableList && (
          <ListSelections
            title={dataListSelected!.title}
            icon={dataListSelected!.icon}
            listCards={dataListSelected!.listCards}
            messageCount={dataListSelected!.messageCount}
            messageEmpty={dataListSelected!.messageEmpty}
            onClinck={dataListSelected!.onClinck}
            onClonse={dataListSelected!.onClonse}
          />
        )}

        {enableCostumer && (
          <CostumerList
            onClinck={(e) => {
              setCostumerSelect(customerMemory.findById(e))

              setCostumer(false)
            }}
            listCards={customerMemory.getListCards(true)}
            onClonse={() => setCostumer(false)}
          />
        )}

        {isCustomerEditOpen && customerSelected && !customerSelected.isDefaultCustomer && (
          <CustomerPopup
            title={i18next.t("customer:title_customer_edite")}
            costumer={customerSelected}
            onClonse={handleCloseCustomerEdit}
          />
        )}

        {isCancel && (
          <CancelOrderPupop icon={faWarning} order={order} onSave={handleSaved} onClonse={() => setIsCancel(false)} />
        )}

        {isPayment && (
          <DetailsPaymentPupop order={orderFinal} onSave={handleSaved} onClonse={() => setPayment(false)} />
        )}
      </div>

      {order && (
        <OrderPrintOptionsPupop
          isOpen={isPrintTargetModalOpen}
          title={t("title_print_target")}
          orderId={order.id}
          printScope="customer"
          onClose={() => setIsPrintTargetModalOpen(false)}
        />
      )}
    </ModalPortal>
  )
}
